import { render, staticRenderFns } from "./phoneMarketing.vue?vue&type=template&id=005b6be5&scoped=true"
import script from "./phoneMarketing.vue?vue&type=script&lang=js"
export * from "./phoneMarketing.vue?vue&type=script&lang=js"
import style0 from "./phoneMarketing.vue?vue&type=style&index=0&id=005b6be5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005b6be5",
  null
  
)

export default component.exports